import { render, staticRenderFns } from "./step-4.vue?vue&type=template&id=2e14a1fb"
import script from "./step-4.vue?vue&type=script&lang=js"
export * from "./step-4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports